// src/__internal__/plugins/PluginsProvider.tsx
import { createContext } from "react";
import { jsx } from "react/jsx-runtime";
var PluginsContext = createContext(null);
var PluginsProvider = ({
  children,
  value
}) => /* @__PURE__ */ jsx(PluginsContext.Provider, { value, children });
PluginsProvider.displayName = "PluginsProvider";
export {
  PluginsContext,
  PluginsProvider
};
